export const ADMIN_MED_LIST_REQUEST = "ADMIN_MED_LIST_REQUEST";
export const ADMIN_MED_LIST_SUCCESS = "ADMIN_MED_LIST_SUCCESS";
export const ADMIN_MED_LIST_FAIL = "ADMIN_MED_LIST_FAIL";

export const ADMIN_MED_CREATE_REQUEST = "ADMIN_MED_CREATE_REQUEST";
export const ADMIN_MED_CREATE_SUCCESS = "ADMIN_MED_CREATE_SUCCESS";
export const ADMIN_MED_CREATE_FAIL = "ADMIN_MED_CREATE_FAIL";

export const ADMIN_MED_UPDATE_REQUEST = "ADMIN_MED_UPDATE_REQUEST";
export const ADMIN_MED_UPDATE_SUCCESS = "ADMIN_MED_UPDATE_SUCCESS";
export const ADMIN_MED_UPDATE_FAIL = "ADMIN_MED_UPDATE_FAIL";

export const ADMIN_MED_DELETE_REQUEST = "ADMIN_MED_DELETE_REQUEST";
export const ADMIN_MED_DELETE_SUCCESS = "ADMIN_MED_DELETE_SUCCESS";
export const ADMIN_MED_DELETE_FAIL = "ADMIN_MED_DELETE_FAIL";

export const ADMIN_MED_ADD_STOCK_REQUEST = "ADMIN_MED_ADD_STOCK_REQUEST";
export const ADMIN_MED_ADD_STOCK_SUCCESS = "ADMIN_MED_ADD_STOCK_SUCCESS";
export const ADMIN_MED_ADD_STOCK_FAIL = "ADMIN_MED_ADD_STOCK_FAIL";

export const ADMIN_MED_REPORT_REQUEST = "ADMIN_MED_REPORT_REQUEST";
export const ADMIN_MED_REPORT_SUCCESS = "ADMIN_MED_REPORT_SUCCESS";
export const ADMIN_MED_REPORT_FAIL = "ADMIN_MED_REPORT_FAIL";

export const ADMIN_MED_TOP_REQUEST = "ADMIN_MED_TOP_REQUEST";
export const ADMIN_MED_TOP_SUCCESS = "ADMIN_MED_TOP_SUCCESS";
export const ADMIN_MED_TOP_FAIL = "ADMIN_MED_TOP_FAIL";

export const ADMIN_MED_SELL_REQUEST = "ADMIN_MED_SELL_REQUEST";
export const ADMIN_MED_SELL_SUCCESS = "ADMIN_MED_SELL_SUCCESS";
export const ADMIN_MED_SELL_FAIL = "ADMIN_MED_SELL_FAIL";
